<template>
	<form class="login-form edit-form" action="javascript:void(0)" method="post">
		<div class="login-title">修改密码</div>
		<input class="oldPsw" type="password" name="oldPsw" v-model="oldPsw" value="" placeholder="输入原密码" />
		<div class="tipCommon"></div>
		<input class="newPsw" type="password" name="newPsw" v-model="newPsw" value="" placeholder="输入新密码" />
		<div class="tipCommon"></div>
		<input class="confirmPsw" type="password" name="confirmPsw" v-model="confirmPsw" value="" placeholder="确认新密码" />
		<div class="tipCommon"></div>
		<input type="submit" class="submit-btn" name="login-submit" id="loginSubmit" value="完成" @click="editPsdFun" />
	</form>
</template>

<script>
	export default {
		name: 'editPassword',
		data() {
			return {
				oldPsw: "",
				newPsw: "",
				confirmPsw: ""
			}
		},
		created: function() {},
		mounted: function() {},
		methods: {
			editPsdFun: function() {
				if(!this.oldPsw) {
					this.common.newTip($(".oldPsw"), "请输入原密码")
					return;
				}
				if(!this.newPsw) {
					this.common.newTip($(".newPsw"), "请输入新密码")
					return;
				}
				if(!this.confirmPsw) {
					this.common.newTip($(".confirmPsw"), "请确认新密码")
					return;
				}
				if(this.newPsw != this.confirmPsw) {
					this.common.newTip($(".confirmPsw"), "确认密码与新密码不同")
					return;
				}
				if(!this.newPsw.match(/^[a-z,A-Z][\w]{5,19}$/i)) {
					this.common.newTip($(".newPsw"), "密码请输入6-20个包含字母和数字，首字母必须是字母")
					return false;
				}
				let data = {};
				data.oldPassword = this.oldPsw;
				data.newPassword = this.newPsw;
				data.id = this.getLocalUser.id
				let _this = this;
				this.common.post("user/modifyPassword", function(ret) {
					_this.layer.closeAll('loading');
					if(ret.errcode == 1001) {
						_this.common.newTip($(".oldPsw"), "密码错误")
						return;
					}
					if(ret.errcode == 0) {
						localStorage.removeItem("user");
						location.href = "/login";
					}
				}, data, true, function() {
					let index = _this.layer.load(1, {
						shade: [0.1, '#fff'] //0.1透明度的白色背景
					});
				})
			}
		}

	}
</script>

<style scoped="scoped">
	@import url("../../../static/css/login.css");
	.edit-form {
		margin-top: 200px;
		-webkit-box-shadow: 0 3px 12px 0 transparent;
		box-shadow: 0 3px 12px 0 transparent;
	}
</style>


// WEBPACK FOOTER //
// src/components/loginPage/editPsw.vue